import LinkTab from "@/src/components/LinkTab/LinkTab";
import { Tabs, TabsProps } from "@mui/material";
import React from "react";
import { NavigationBarDesktopProps } from "@/src/components/Navigation/NavigationBar/Desktop/NavigationBarDesktop";

type SubnavigationTabsProps = {
  value: TabsProps["value"];
  items: Extract<NavigationBarDesktopProps["mainNavigationItems"][number], { type: "category" }>["categoryMapping"];
};

export default function SubnavigationTabs({ items, value }: SubnavigationTabsProps) {
  return (
    <Tabs
      variant={"scrollable"}
      value={value}
      sx={{ padding: "0.75rem 0.5rem" }}
      slotProps={{
        list: {
          sx: {
            position: "relative",
            zIndex: 1,
          },
        },
        indicator: {
          sx: (theme) => ({
            height: "100%",
            borderRadius: "0.25rem",
            backgroundColor: theme.palette.primaryPale,
          }),
        },
      }}
    >
      {items.map((item) => (
        <LinkTab label={item.label} to={item.to} value={item.to} selected={item.to === value} sx={{ padding: "1rem" }} />
      ))}
    </Tabs>
  );
};
